import React from 'react';
import HeaderComponent from '../../common-components/HeaderComponent/HeaderComponent';
import './styles/blacklistedInfluencer.scss';
import BlacklistTable from './tables/BlacklistTable';

const BlackListedInfluencers = () => {
  return (
    <div className="">
      <HeaderComponent
        showSearchBar={false}
        title="Blacklist Settings > Blacklisted Influencers"
      />
      <div className="blacklist-influencer-main-container">
        <BlacklistTable />
      </div>
    </div>
  );
};

export default BlackListedInfluencers;
